import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dropdown", "input"]

  connect() {
    const link = this.dropdownTarget.querySelector("a")
    if (link) {
      link.addEventListener("click", () => this.hideImmediately())
    }
    // Set initial aria-expanded state
    if (this.hasInputTarget) {
      this.inputTarget.setAttribute("aria-expanded", "false")
    }
  }

  show() {
    this.dropdownTarget.classList.remove("hidden")
    if (this.hasInputTarget) {
      this.inputTarget.setAttribute("aria-expanded", "true")
    }
  }

  hide(event) {
    setTimeout(() => {
      if (!this.element.contains(document.activeElement)) {
        this.dropdownTarget.classList.add("hidden")
        if (this.hasInputTarget) {
          this.inputTarget.setAttribute("aria-expanded", "false")
        }
      }
    }, 200)
  }

  hideImmediately() {
    this.dropdownTarget.classList.add("hidden")
    if (this.hasInputTarget) {
      this.inputTarget.setAttribute("aria-expanded", "false")
    }
  }

  disconnect() {
    const link = this.dropdownTarget.querySelector("a")
    if (link) {
      link.removeEventListener("click", () => this.hideImmediately())
    }
  }
}
